import * as React from 'react';

interface Props {
  className?: string;
}

export default function SearchIcon({className}: Props): JSX.Element {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <defs>
        <path id="a" d="M0 0h20v20H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b123456" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <circle stroke="#FFA300" strokeWidth="2" mask="url(#b)" cx="8.5" cy="9.5" r="6.5" />
        <path
          stroke="#FFA300"
          strokeWidth="2"
          strokeLinecap="round"
          mask="url(#b123456)"
          d="m14 14 4 4"
        />
      </g>
    </svg>
  );
}
